import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-04-14'
        tag='eBay'
        title='eBay Buyer Groups: Promote your coded coupons in bulk!'
      >
        <p>
          Business success relies on many factors, one of which is having repeat buyers. This group of people is an
          essential part of your market as they are considered the most profitable since they can also affect your
          acquisition. While many businesses underestimate the power of referral, you shouldn't. One of the leading ways
          to improve your sales and customer acquisition is through recommendations from shoppers that have purchased
          from you before, which ultimately helps grow your business.{' '}
        </p>
        <p>
          When selling online, the most challenging part is how to encourage your buyers to purchase from you again.
          That is why it is crucial to formulate ways and strategies to reach out again and make them buy from your
          store instead of your competitors in the market.
        </p>
        <p>
          Influencing your previous buyers to buy from you again is tricky. eBay understands this; hence, they developed
          the eBay Buyer Groups to help sellers like you reach out to your buyers and offer them promotions such as
          coded coupons.
        </p>
        <p>Read on and learn how to use this feature to further your eBay store's success.</p>

        <h3>What are eBay Buyer Groups?</h3>
        <p>
          eBay Buyer Groups is a specific group of shoppers who qualifies to use your coded coupons. These buyers have
          purchased from you previously; hence the Buyer Insights section lets you know how many buyers you've had in
          the past, including your one-time buyers and repeat buyers.
        </p>
        <p>
          This feature lets you decide which parameters your buyers would fall under and whether you would like to send
          coupons to those who purchased from you in the last 31 days, more than three months, or more than six months.
        </p>

        <h3>The Benefits</h3>
        <p>
          Sellers like you can benefit from using Buyer Groups as it offers you more control over who gets to have a
          discount using the coded coupons you made. Here are the great things about using this feature:
        </p>
        <ul>
          <li>
            It can help boost your sales by establishing a good relationship with your previous buyers and encouraging
            them to buy again from you using the coded coupons.
          </li>
          <li>
            You don't have to publicly advertise your ongoing discount as sending your coupons to a Buyer Group means it
            is a private offer.
          </li>
          <li>It lets you control what categories of your collection you want to promote.</li>
          <li>
            It gives you the option of whether to send your coded coupons to your buyers through email or in-app
            notification.
          </li>
          <li>
            It offers flexibility in your budget and profit margins as you can control the minimum spend, expiration
            date, and budget.
          </li>
        </ul>

        <h3>What are Coded Coupons?</h3>
        <p>
          Coded coupons are your best friend when it comes to offering discounts to your previous buyers and potential
          buyers. You can share these coded coupons publicly by printing them out and sending them to those who buy from
          your store to encourage a repeat order, share them on social media platforms, or give them to your friends.
          You can also share them privately through your marketing channel, like eBay Buyer Groups.{' '}
        </p>
        <p>
          This marketing strategy helps you become tactical if you want to have control over encouraging repeat
          purchases, your budget and profit margin, and when you want to offer discounts without changing the price of
          your listings.
        </p>

        <h3>Creating Coded Coupons</h3>
        <p>
          When creating your coded coupon, you must decide what kind of discount you would like to offer. It can be any
          of the following:
        </p>
        <ul>
          <li>
            <strong>Set price reduction.</strong> This is where your buyers can get a specific discount when they reach
            a certain amount spent. For example, your buyers can get $2 less when they spend a minimum of $40.{' '}
          </li>
          <li>
            <strong>Percentage discount.</strong> This kind of discount depends on the amount of their total. For
            example, your buyers can get 10% off when they spend a minimum amount of $60, and the maximum discount they
            can get is $10.
          </li>
          <li>
            <strong>Multi-item offer.</strong> This kind of discount applies when buyers get multiple items in your
            category. For example, they can get one free item if they buy two items (Buy 2 Get 1), or Buy one and get
            the other one at 50% off.
          </li>
        </ul>
        <p>To create a coded coupon, follow these steps:</p>
        <ol>
          <li>Log into Seller Hub</li>
          <li>Generate your desired code</li>
          <li>Indicate the requirements such as type of discount and max budget</li>
          <li>Pick your inventory where you would want the code to apply</li>
          <li>Launch your code.</li>
        </ol>
        <p>
          <strong>Note:</strong> You can become creative when it comes to the code you like, i.e., SPRING2022OFF and so
          on. Also, don't forget to include the validity date and your terms and conditions when creating your coded
          coupon.{' '}
        </p>

        <h3>Sending Coupons</h3>
        <p>
          Now that you know how these coded coupons can help you reel in more buyers and increase your sales, it is time
          to learn how you can send coded coupons to specific buyer groups.
        </p>
        <p>
          By accessing the Seller Hub Marketing tab, you can access the new Buyer Groups section. This is where you can
          find:
        </p>
        <ol>
          <li>
            <strong>Create a buyer group</strong> - Here is where you can choose the group of buyers that will receive
            your coded coupons.
          </li>
          <li>
            <strong>Choose your campaign</strong> - This section is where you can choose the existing coded coupon
            campaign you want to use or create a new one.
          </li>
          <li>
            <strong>Add a custom message</strong> - Don't forget to include a message to your buyers that you will send
            along with your coupon. This adds a personal touch to your offer.
          </li>
          <li>
            <strong>Send your coupons</strong> - Eligible buyers in your groups will receive your coupon codes.
          </li>
        </ol>
        <p>
          Note: eBay only allows sellers to send one coupon to buyers every 14 days. That is why you must ensure that
          you only select the most relevant buyer group for the coded coupons you have.
        </p>

        <h3>Boost Your Sales with OneShop</h3>
        <p>
          Using the eBay Buyer Groups is indeed an advantage in ensuring a broader reach of potential buyers that can
          eventually increase your sales on the platform. But did you know that you can maximize your earning potential
          by expanding your market and tapping into a more significant number of shoppers?{' '}
        </p>
        <p>
          Making your listings visible on other eCommerce platforms like Poshmark, Mercari, Depop, Tradesy, and more can
          undoubtedly grow your business and ultimately get more customers who can turn into repeat buyers. To do this,
          cross-listing is the way to go.
        </p>
        <p>
          A great cross-listing and automation tool like OneShop is ideal for sellers like you who manage multiple
          online stores on different platforms as it can save you tons of time to help you do other essential things
          that can grow your business. You only have to draft once using the app and cross-list hassle-free to other
          marketplaces that OneShop supports.{' '}
        </p>
        <p>
          In addition to this, if an item is sold on another platform, OneShop will automatically delist them on other
          marketplaces to help you avoid having problems when multiple buyers buy the same item at once.
        </p>
        <p>
          Visit <a href='https://tools.oneshop.com/'>OneShop</a> today to know more, and sign up to try our{' '}
          <a href='https://tools.oneshop.com/signup'>7-day free trial</a> to experience how convenient having OneShop is
          and how helpful it is to your online venture.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
